import { createMuiTheme } from '@material-ui/core/styles';

export default createMuiTheme({
  typography: {
    useNextVariants: true
  },
  palette: {
    primary: {
      light: '#F6861E',
      main: '#F6861E',
      dark: '#F6861E',
      contrastText: '#fff'
    },
    secondary: {
      light: '#F6861E',
      main: '#F6861E',
      dark: '#F6861E',
      contrastText: '#000'
    }
  }
});
